// Common configurations related to YourOrder scope.

// pers rec consent type
export const PERS_REC_CONSENT_TYPE = {
  ON: 'ON',
  OFF: 'OFF'
};
